// @ts-strict-ignore
import { CtaButtonRowLink } from './CtaButtonRowLink'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Icon } from '@components/old-rolex-ui'
import { cn } from '@lib/cn'
import { useRolexEventTracking } from '@lib/hooks/use-rolex-track-events'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

interface Props {
  variant?: 'white' | 'transparent'
  isHorizontal?: boolean
  sendMessage?: boolean
  findStore?: boolean
  phoneNumber?: string
  directionsUrl?: string
  detailSlug?: string
}

const CtaButtons: FC<Props> = ({
  variant = 'transparent',
  isHorizontal = false,
  sendMessage = false,
  findStore = false,
  phoneNumber,
  directionsUrl,
  detailSlug,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('rolex')
  const { track } = useRolexEventTracking()

  const handleSmoothScroll = (e) => {
    e.preventDefault()
    const contact = document.getElementById('contact')

    if (contact) {
      window.scroll({ top: contact.offsetTop, left: 0, behavior: 'smooth' })
    }
  }

  const handleDirectionsClick = (e, href: string) => {
    e.preventDefault()
    track('getDirections')
    window.open(href, '_blank')
  }

  const handlePhoneClick = (e, href: string) => {
    e.preventDefault()
    track('contactCall')
    window.location.href = href
  }

  const handleFindStoreClick = (e) => {
    e.preventDefault()
    track('findStore')
    window.location.href = `/${language}/rolex-certified-pre-owned/contact`
  }

  return (
    <ul
      className={cn(
        'flex flex-row justify-center',
        isHorizontal && 'lg:justify-evenly',
        !isHorizontal && 'lg:flex-col',
      )}
    >
      {phoneNumber && (
        <CtaButtonRowLink
          onClick={(e) => handlePhoneClick(e, `tel:+31206225333`)}
          title={`${t('cta.call')} ${phoneNumber}`}
          variant={variant}
          icon={<Icon size={20} icon="phone"></Icon>}
        >
          <span className="hidden font-light text-current lg:block">
            {t('cta.call')} {phoneNumber}
          </span>
        </CtaButtonRowLink>
      )}
      {sendMessage && (
        <CtaButtonRowLink
          href="#contact"
          onClick={handleSmoothScroll}
          title={t('cta.message')}
          variant={variant}
          icon={<Icon size={20} icon="mail"></Icon>}
        >
          <span className="hidden font-light text-current lg:block">{t('cta.message')}</span>
        </CtaButtonRowLink>
      )}
      {findStore && (
        <CtaButtonRowLink
          onClick={(e) => handleFindStoreClick(e)}
          title={t('cta.store')}
          variant={variant}
          icon={<Icon size={20} icon="location"></Icon>}
        >
          <span className="hidden font-light text-current lg:block">{t('cta.store')}</span>
        </CtaButtonRowLink>
      )}
      {directionsUrl && (
        <CtaButtonRowLink
          onClick={(e) => handleDirectionsClick(e, directionsUrl)}
          title={t('cta.getDirections')}
          target="blank"
          variant={variant}
          icon={<Icon size={20} icon="directions"></Icon>}
        >
          <div className="hidden items-center font-rolex font-light lg:flex ">
            {t('cta.getDirections')}
            <Icon ml="1" size={[16, 20]} icon="externalLink"></Icon>
          </div>
        </CtaButtonRowLink>
      )}
      {detailSlug && (
        <LocalizedLink href={`/rolex-certified-pre-owned/contact/${detailSlug}`}>
          <CtaButtonRowLink
            href={`/rolex-certified-pre-owned/contact/${detailSlug}`}
            title={t('cta.moreDetails')}
            variant={variant}
            icon={<Icon size={20} icon="plus"></Icon>}
          >
            <span className="hidden font-light sm:block">{t('cta.moreDetails')}</span>
          </CtaButtonRowLink>
        </LocalizedLink>
      )}
    </ul>
  )
}

export default CtaButtons
